import type { MetadataFields, Metadatafieldtypes } from '../../MetadataFields.ts'
import { isExistingMetadataField } from '../../MetadataFields.ts'
import { MetadataFieldSelect } from './MetadataFieldSelect.tsx'
import { isSortByOperation, type BoundOperation } from '../../OperationTypes.ts'
import type { SortByOperationKey } from '../../OperationRegistry.ts'
import { OPERATION_REGISTRY, OPERATIONS } from '../../OperationRegistry.ts'
import { useMemo } from 'react'
import type { VisualizationSampleContainer } from '../../VisualizationSampleContainer.js'

interface SortByEditorRowProps {
  boundSortByOperation: BoundOperation<SortByOperationKey, unknown>
  metadataFields: MetadataFields
  onChange: (next: BoundOperation<SortByOperationKey, unknown>) => void
  onRemove: () => void
  samples: VisualizationSampleContainer[]
}

export const SortByEditorRow = (props: SortByEditorRowProps) => {
  const fieldDescriptor = props.metadataFields[props.boundSortByOperation.metaDataField]

  const applicableOps = useMemo(() => {
    console.log(props.boundSortByOperation.metaDataField)
    console.log(fieldDescriptor)
    if (!fieldDescriptor) return []
    return OPERATIONS.filter((op) => op.type === 'sort' && op.applicableTo.includes(fieldDescriptor.type))
  }, [fieldDescriptor])

  const handleFieldChange = (newField: string) => {
    if (!isExistingMetadataField(newField, props.metadataFields))
      throw Error('invalid field: ' + newField + ' in ' + Object.keys(props.metadataFields).join(','))
    const newDescriptor = props.metadataFields[newField]
    const firstValid = OPERATIONS.filter((op) => isSortByOperation(op)).find((op) => op.applicableTo.includes(newDescriptor.type))
    if (!firstValid) return

    props.onChange({
      operationKey: firstValid.key,
      /* handwavy fix for typescript, as this may be custom types */
      metaDataField: newField as Metadatafieldtypes,
      config: firstValid.config?.defaultConfig ?? {}
    })
  }

  const handleOperatorChange = (opKey: SortByOperationKey) => {
    const newOp = OPERATION_REGISTRY[opKey]
    if (!newOp || !isSortByOperation(newOp)) return

    let newConfig: unknown = newOp.config?.defaultConfig ?? {}
    if (newOp.config?.verifyConfig && newOp.config.verifyConfig(props.boundSortByOperation.config)) {
      newConfig = props.boundSortByOperation.config
    }

    props.onChange({
      ...props.boundSortByOperation,
      operationKey: newOp.key,
      config: newConfig
    })
  }

  return (
    <div className="flex items-center gap-2 w-full">
      {/* Field selector */}
      <MetadataFieldSelect
        metadataFields={props.metadataFields}
        value={props.boundSortByOperation.metaDataField}
        onChange={handleFieldChange}
        samples={props.samples}
      />

      {/* Operator select */}
      <select
        className="select select-sm select-bordered"
        value={props.boundSortByOperation.operationKey}
        onChange={(e) => handleOperatorChange(e.target.value as SortByOperationKey)}
        disabled={!fieldDescriptor}
      >
        {applicableOps.map((op) => (
          <option key={op.key} value={op.key}>
            {op.label}
          </option>
        ))}
      </select>

      <button className="btn btn-xs btn-outline btn-error" onClick={props.onRemove}>
        ✕
      </button>
    </div>
  )
}
